import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const costFaqs: LearnFAQ[] = [
  {
    question: "¿Cuánto cuesta SAINT® TMS?",
    answer:
      "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. La cobertura del seguro varía según el plan; verificamos sus beneficios sin costo. [[Vea el costo de SAINT®|/es/learn/saint-tms-cost]] o llame al 954-827-9793.",
  },
  {
    question: "¿Cubre el seguro SAINT® TMS?",
    answer:
      "La cobertura varía según el plan. Es posible que esté cubierto; verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora.",
  },
];

export const esSaintCostHub = makeEsArticle({
  slug: "saint-tms-cost-hub",
  title: "Costo de SAINT® TMS | Neuro Wellness",
  description:
    "Costo de SAINT® TMS: pago directo ($25,000–$28,000), cobertura del seguro y verificación de beneficios sin costo.",
  h1: "Costo de SAINT® TMS",
  breadcrumbLabel: "Costo de SAINT®",
  shortAnswer:
    "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. La cobertura del seguro varía según el plan; es posible que esté cubierto. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  keyTakeaways: [
    "El pago directo puede oscilar entre $25,000 y $28,000.",
    "La cobertura del seguro varía según el plan.",
    "Es posible que esté cubierto.",
    "Verificamos sus beneficios sin costo.",
    "No afirmamos estar dentro de la red de ninguna aseguradora.",
  ],
  sections: [
    {
      heading: "Pago directo",
      paragraphs: [
        "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. El costo exacto depende de su caso.",
      ],
    },
    {
      heading: "Seguro",
      paragraphs: [
        "La cobertura del seguro varía según el plan. Es posible que esté cubierto. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs: costFaqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);

export const esSaintCostInsuranceCoverage = makeEsArticle({
  slug: "saint-tms-cost-insurance-coverage",
  title: "Costo y cobertura del seguro de SAINT® TMS | Neuro Wellness",
  description:
    "Costo y cobertura del seguro de SAINT® TMS: pago directo, verificación de beneficios sin costo y cómo planificar el pago.",
  h1: "Costo y cobertura del seguro de SAINT® TMS",
  breadcrumbLabel: "Costo y seguro de SAINT®",
  shortAnswer:
    "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. La cobertura del seguro varía según el plan; es posible que esté cubierto. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
  keyTakeaways: [
    "El pago directo puede oscilar entre $25,000 y $28,000.",
    "La cobertura varía según el plan.",
    "Verificamos sus beneficios sin costo.",
    "No afirmamos estar dentro de la red de ninguna aseguradora.",
  ],
  sections: [
    {
      heading: "Costo",
      paragraphs: [
        "El pago directo para SAINT® puede oscilar entre $25,000 y $28,000. [[Vea el costo de SAINT®|/es/learn/saint-tms-cost]] o llame al 954-827-9793.",
      ],
    },
    {
      heading: "Cobertura del seguro",
      paragraphs: [
        "La cobertura varía según el plan. Es posible que esté cubierto. Verificamos sus beneficios sin costo, sea cual sea su aseguradora. No afirmamos estar dentro de la red de ninguna aseguradora; la cobertura varía según el plan. [[Verifique sus beneficios|/es/saint-tms-insurance-coverage]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs: costFaqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
